export default __webpack_public_path__ + "static/media/favors1.9f1eceaf.jpg";